import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ReactGA from 'react-ga';

ReactGA.initialize('UA-185380552-3');
ReactDOM.render(<App />, document.getElementById("root"));
